import React from "react";
import { Trans } from "react-i18next";

import { Field, Flex, PinInput } from "@chakra-ui/react";
import { getTrackingId } from "../../helpers/getTrackingId";
import { ClassEnums } from "../../utils/enums/ClassEnums";

interface PropTypes {
  value: string[];
  handleInputChange: (value: string[]) => void;
  label?: string;
  isInvalid?: boolean;
  isDisabled?: boolean;
  pinErrorMessage?: string;
  pinLength?: number;
  size?: "2xs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
}

const PinCodeInput: React.FC<PropTypes> = ({
  value,
  handleInputChange,
  pinErrorMessage,
  label,
  isInvalid = false,
  isDisabled = false,
  pinLength = 4,
  size = "2xl"
}) => {
  return (
    <Field.Root data-bark-component="PinCodeInput" invalid={!!isInvalid}>
      {label && (
        <Field.Label
          textStyle="body.standard"
          fontWeight="medium"
          color="text.soft"
        >
          <Trans>{label}</Trans>
        </Field.Label>
      )}

      <PinInput.Root
        otp
        placeholder=""
        value={value}
        onValueChange={details => handleInputChange(details.value)}
        disabled={isDisabled}
        size={size}
      >
        <PinInput.HiddenInput />
        <Flex gap={{ base: 3, md: 4, lg: 8 }} justify="center">
          {Array.from({ length: pinLength }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <PinInput.Control key={index}>
              <PinInput.Input
                index={index}
                className={ClassEnums.Input}
                data-tracking-id={getTrackingId(
                  [ClassEnums.Input],
                  `code-${index}`
                )}
                data-testid={`pin-input-${index}`}
              />
            </PinInput.Control>
          ))}
        </Flex>
      </PinInput.Root>

      {isInvalid && pinErrorMessage && (
        <Field.ErrorText color="text.error" textStyle="body.standard">
          <Trans>{pinErrorMessage}</Trans>
        </Field.ErrorText>
      )}
    </Field.Root>
  );
};

export default PinCodeInput;
